export default "<input type=\"hidden\" [name]=\"fieldID\" [(ngModel)]=\"value\"/>"